import React, { useState } from 'react';
import Button from 'components/Button';
import { buttonVariants } from 'components/Button/index.style.js';
import { TextBodySmall } from 'components/TextStyles';
import IconArrowheadRight from 'components/_svgs/IconArrowheadRight';
import gsap from 'gsap';
import { TextPlugin } from 'gsap/TextPlugin';
import Routes from 'routes';
import styled from 'styled-components';
import { colors } from 'styles/vars/colors.style';
import { mq } from 'styles/vars/media-queries.style';
import { TextStyle } from 'styles/vars/textStyles.style.js';
import addToMailchimp from 'utils/mailchimp';



gsap.registerPlugin(TextPlugin);

// subscribes user to the mailing list on the blog page
const Subscribe = () => {
  const [email, setEmail] = useState('');
  const [messageEl, setMessageEl] = useState(null);

  const submitForm = (e) => {
    e.preventDefault();

    addToMailchimp(Routes.subscribe.endpoint, email, Routes.subscribe.tags)
      .then((res) => {
        let color;
        let text;

        if (res.result === 'success') {
          window?.posthog.capture('blog:subscribe_form_submit', {
            $set: { email: email },
            $set_once: { initial_url: '/blog' },
            subscribeUrl: window?.location?.href,
            subscribeDate: new Date().toISOString(),
          });
          color = '#00923A';
          text = "Success! You've been added to our mailing list.";
        } else {
          color = '#CF1818';
          text = res.msg;
        }

        gsap.set(messageEl, {
          text: text || 'There was an error.',
        });

        gsap.to(messageEl, {
          opacity: 1,
          color,
          onComplete: () => {
            setTimeout(() => {
              gsap.to(messageEl, {
                clearProps: 'all',
              });
            }, 5000);
          },
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Wrapper>
      <TextBodySmall>
        Sign up now to get notified of any updates or new articles.
      </TextBodySmall>
      <Form onSubmit={submitForm}>
        <Input
          placeholder="Enter email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            // If the user starts typing, capture the event
            if (e.target.value.length > 2) {
              window?.posthog.capture('blog:subscribe_form_start', {
                email: e.target.value,
              });
            }
          }}
        />
        <Button
          variant={buttonVariants.plain}
          iconRight={<IconArrowheadRight />}
          ariaLabel={`Submit`}
          type={`submit`}
        ></Button>
      </Form>
      <Message ref={(ref) => setMessageEl(ref)}></Message>
    </Wrapper>
  );
};

export default Subscribe;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;

  ${mq.contained} {
    gap: 1.04vw;
  }
`;

const Form = styled.form`
  position: relative;
  width: 100%;

  button {
    position: absolute;
    right: 0;
    top: 5px;
  }

  ${mq.contained} {
    top: 0.26vw;
  }
`;

const Input = styled.input`
  border: none;
  border-bottom: 1px solid ${colors.humeBlack400};
  outline: none !important;
  width: 100%;
  height: 28px;
  background: transparent;
  padding-right: 40px;
  ${TextStyle.TextBodySmall}
  padding-bottom: 10px;
  border-radius: 0;

  &[type='search'] {
    appearance: none;
  }

  ${mq.contained} {
    height: 1.46vw;
    padding-bottom: 0.52vw;
    padding-right: 2.08vw;
  }
`;

const Message = styled.span`
  position: absolute;
  ${TextStyle.TextBodySmall}
  font-size: 8px;
  opacity: 0;
  top: 110%;

  ${mq.contained} {
    font-size: 0.44vw;
    text-transform: capitalize;
  }
`;
